import { render, staticRenderFns } from "./IconLinkBtn.vue?vue&type=template&id=3345f67d&scoped=true"
import script from "./IconLinkBtn.vue?vue&type=script&lang=js"
export * from "./IconLinkBtn.vue?vue&type=script&lang=js"
import style0 from "./IconLinkBtn.vue?vue&type=style&index=0&id=3345f67d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345f67d",
  null
  
)

export default component.exports